import {PatTipoBemModel} from '@/models/patrimonio/pattipobem/pattipobem.model';
import api from '@/services/axios/api';
import {AxiosResponse} from 'axios';
import {DataSource, FiltrosModel} from '@/datasources/consulte-grid';
import TextoValor from '@/models/texto-valor';
import {RegisterOutput} from '@/models/register-output';
import router from '@/routes';


class PatTipoBemService {
 dadosIndexPaginadoPorGrupo(
  pagina: number,
  itensPorPagina: number,
  filters: FiltrosModel[],
  patGrupoId: number
 ): Promise<AxiosResponse<DataSource<PatTipoBemModel>>> {
  return api.post<DataSource<PatTipoBemModel>>(
   '/PatTipoBem/RetornoPaginado',
   {
    rowsPerPage: itensPorPagina,
    pageNumber: pagina,
    filters: filters
   },
   {
    params: {
     PatGrupoId: patGrupoId,
    },
   }
  );
 }

 dadosIndexPaginado(
    pagina: number,
    itensPorPagina: number,
    filters: FiltrosModel[]
  ): Promise<AxiosResponse<DataSource<PatTipoBemModel>>> {
    const routePath = router.currentRoute.value.path;
    const lsItens = routePath.split('/').filter(Boolean);

    const patGrupoId = Number(lsItens[lsItens.length - 1]);

    return this.dadosIndexPaginadoPorGrupo(pagina, itensPorPagina, filters, patGrupoId);
  }

 inserirAtualizar(patTipoBem: PatTipoBemModel): Promise<AxiosResponse<RegisterOutput>> {
  const result = api.post('/PatTipoBem', patTipoBem);
  return result;
 }

 remover(id: number): Promise<AxiosResponse> {
  return api.delete('/PatTipoBem/' + id);
 }

 atualizar(patTipoBem: PatTipoBemModel): Promise<AxiosResponse> {
  return api.put('/PatTipoBem', patTipoBem);
 }

 async get(id: number): Promise<PatTipoBemModel> {
  const result = await api.get<PatTipoBemModel>(`/PatTipoBem/${id.toString()}`);
  return result.data;
 }
 async DropDownList() : Promise<TextoValor[]> {
  const endpoint = "/PatTipoBem/DropDownList";
  const result = await api.get(endpoint);
  // Mapeando os dados para o formato TextoValor
  return result.data.map((item: any) => ({
   valor: item.valor,
   texto: item.texto,
   }));
 }
}
export default new PatTipoBemService();
